import { render, staticRenderFns } from "./ExclusionList.vue?vue&type=template&id=3f1dc529&scoped=true"
import script from "./ExclusionList.vue?vue&type=script&lang=js"
export * from "./ExclusionList.vue?vue&type=script&lang=js"
import style0 from "./ExclusionList.vue?vue&type=style&index=0&id=3f1dc529&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1dc529",
  null
  
)

export default component.exports